

import React from 'react';

import {Modal, ModalHeader, ModalBody, ModalFooter} from 'Components/Modal';
import {DangerButton} from 'Components/Button';

import {translation} from 'Services/TranslationHelpers';
import StandaloneChat from "Components/Networking/StandaloneChat";
import PrimaryButton from "Components/Button/PrimaryButton";
import Link from "Components/Utilities/Link";
import DarkButton from "Components/Button/DarkButton";
import { asset } from "Services/BaseHelpers";

export default class MapModel extends React.Component {
    /**
     * @var state
     */
    state = {
    };


    /**
     * @method render
     * @return {JSX.Element}
     */
    render() {
        const {onClose, user, selectedArea} = this.props;

        return (
            <Modal titleClass="text-app-blue" onClose={onClose} className="bg-white max-h-[40em]">
                <ModalHeader onClose={onClose} className="border-none text-app-blue" titleClassName="text-white" />
                    <ModalBody containerClassName="p-6 max-h-[40em]">
                        <div className="space-y-4">
                            <h2 className="text-xl font-semibold text-app-blue">{selectedArea.name}</h2>
                            {selectedArea.highlightedImage && (
                                <div style={{ textAlign: 'center' }}>
                                    <img
                                        src={selectedArea.highlightedImage}
                                        alt={selectedArea.name}
                                        style={{
                                            maxWidth: '100%',
                                            width: selectedArea.highlightedWidth ? selectedArea.highlightedWidth : 'auto',
                                            height: selectedArea.highlightedHeight ? selectedArea.highlightedHeight : 'auto',
                                            objectFit: 'contain',
                                            margin: '0 auto',
                                        }}
                                    />
                                </div>
                            )}
                            <div>
                                {selectedArea.description
                                    ? (React.isValidElement(selectedArea.description)
                                            ? selectedArea.description
                                            : Array.isArray(selectedArea.description)
                                                ? selectedArea.description.map((text, idx) => <p key={idx} className="text-sm leading-relaxed my-5">{text}</p>)
                                                : String(selectedArea.description).split('\n').map((text, idx) => <p key={idx} className="text-sm leading-relaxed  my-5">{text}</p>)
                                    )
                                    : null
                                }
                            </div>
                        </div>

                    </ModalBody>
            </Modal>
        )
    }
}
